import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface User {
  id: string
  name: string
  email: string
  hasCompletedOnboarding?: boolean
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  hasCompletedOnboarding: boolean
  setAuth: (user: User, token: string) => void
  setUser: (user: User | null) => void
  setOnboardingComplete: (completed: boolean) => void
  logout: () => void
  getToken: () => string | null
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      hasCompletedOnboarding: false,
      setAuth: (user, token) => set({
        user,
        token,
        isAuthenticated: true,
        hasCompletedOnboarding: user.hasCompletedOnboarding || false
      }),
      setUser: (user) => set({
        user,
        isAuthenticated: !!user,
        hasCompletedOnboarding: user?.hasCompletedOnboarding || false
      }),
      setOnboardingComplete: (completed) => set({ hasCompletedOnboarding: completed }),
      logout: () => set({ user: null, token: null, isAuthenticated: false, hasCompletedOnboarding: false }),
      getToken: () => get().token,
    }),
    {
      name: 'auth-storage',
    }
  )
)
